import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import "bootstrap-icons/font/bootstrap-icons.css";
import MapWrapper from "../../../../../Components/UiComponents/MapWrapper/MapWrapper";

// Component for displaying and managing bank data in a view page
const ViewBankDetails = () => {
  const location = useLocation();

  // Try to get data from location.state or fallback to sessionStorage
  const initialBankData =
    location.state?.data || JSON.parse(sessionStorage.getItem("BankData"));

  const bankData = initialBankData;

  // Save to sessionStorage if it's coming from location.state
  useEffect(() => {
    if (location.state?.data) {
      sessionStorage.setItem("BankData", JSON.stringify(location.state.data));
    }
  }, [location.state?.data]);

  // Function to display data or N/A if not available
  const displayData = (data) => data || "N/A";

  // Device type dropdown state for map
  const [selectedMapOption, setSelectedMapOption] = useState("CC Camera");

  // Map configuration for MapWrapper
  const mapTitle = "Bank Location";

  const mapCoordinates = [
    {
      x: bankData?.latitude || 25.4223,
      y: bankData?.longitude || 86.1391,
      locationId: 1,
      popupdata: {
        title: bankData?.bankName,
        description: bankData?.addressLine1,
        status: bankData?.activeStatus ? "Active" : "Inactive",
        type: "Bank",
      },
    },
  ];

  // Handler for map dropdown change
  const handleMapOptionChange = (e) => {
    setSelectedMapOption(e.target.value);
  };

  // Handler for recording chosen coordinates if needed
  const handleChooseCoordinates = (longitude, latitude) => {
    console.log(`Selected coordinates: ${longitude}, ${latitude}`);
  };

  return (
    <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
      <div className="row g-0" style={{ height: "110vh", overflow: "hidden" }}>
        {/* Left Panel - Bank Details with scrollbar */}
        <div className="col-md-8 p-4 bg-white" style={{ height: "100vh" }}>
          {/* Grid Layout for Bank Details - 3 columns with reduced spacing */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            {/* First row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Bank Name
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.bankName)}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                IFSC Code
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.ifscCode)}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Mandal
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.mandal)}
              </p>
            </div>

            {/* Second row */}
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                City
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.city)}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                District
              </p>
              <div className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.district)}
              </div>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Pincode
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.pinCode)}
              </p>
            </div>

            {/* Third row */}

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Contact Name
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.contactName)}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Mobile/Landline Number
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.phoneNumber)}
              </p>
            </div>

            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Active status
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                <span
                  className={`badge ${
                    bankData?.activeStatus ? "bg-success" : "bg-danger"
                  }`}
                >
                  {bankData?.activeStatus ? "Active" : "Inactive"}
                </span>
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Email Address
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.email)}
              </p>
            </div>
            <div>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Website
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.website)}
              </p>
            </div>
            <div>
              <p className="mb-1 small" style={{ color: "#FFA100" }}>
                Created on
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {bankData?.created_on
                  ? new Date(bankData.created_on)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                      .replace(/\//g, "-") +
                    " " +
                    new Date(bankData.created_on).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : "N/A"}
              </p>
            </div>

            <div>
              <p className="mb-1 small" style={{ color: "#FFA100" }}>
                Entry Date
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {bankData?.entryDate
                  ? new Date(bankData.entryDate)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                      .replace(/\//g, "-")
                  : "N/A"}
              </p>
            </div>
            <div style={{ gridColumn: "span 3" }}>
              <p
                className="mb-1 small"
                style={{ color: "#FFA100", fontSize: "13px" }}
              >
                Address
              </p>
              <p className="mb-0" style={{ fontSize: "15px" }}>
                {displayData(bankData?.addressLine1)}
                {bankData?.addressLine2 && (
                  <span>, {bankData.addressLine2}</span>
                )}
              </p>
            </div>
          </div>
        </div>

        {/* Right Panel - Map with MapWrapper component */}
        <div className="col-md-4 p-0" style={{ overflow: "hidden" }}>
          <MapWrapper
            title={mapTitle}
            selectedOption={selectedMapOption}
            onChangeHandler={handleMapOptionChange}
            containerStyles={{
              height: "85vh",
              display: "flex",
              flexDirection: "column",
            }}
            headerStyles={{
              backgroundColor: "#1a7a73",
              color: "white",
              padding: "8px 16px",
            }}
            bodyStyles={{
              flex: 1,
              overflow: "hidden",
            }}
            coordinates={mapCoordinates}
            chooseCoordinates={handleChooseCoordinates}
            zoom={13}
            popUpShow={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewBankDetails;
